import { maxWidth, minWidth, width } from "@mui/system";
import theme from "../../../../theme";

/**
 * Helper function to calculate border radius for toggle buttons
 * @param {number} index - Current button index
 * @param {number} total - Total number of buttons
 * @returns {string} - Border radius value
 */
const getBorderRadius = (index, total) => {
  if (index === 0) return "0.5rem 0 0 0.5rem";
  if (index === total - 1) return "0 0.5rem 0.5rem 0";
  return "0";
};

/**
 * Styles for the main form container
 * @type {Object}
 */
export const formContainer = {
  flex: 1,
  padding: "1rem",
  maxWidth: "none !important",
  backgroundColor: theme.palette.background.paper,
};

/**
 * Styles for the form element
 * @type {Object}
 */
export const formStyle = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

/**
 * Styles for grid items
 * @type {Object}
 */
export const gridItem = {
  width: "19%",
  minWidth: "15rem",
};

/**
 * Styles for form labels
 * @type {Object}
 */
export const labelText = {
  color: theme.palette.text.primary,
  mb: 2,
  fontFamily: theme.typography.fontFamily,
};

/**
 * Styles for form controls
 * @type {Object}
 */
export const formControl = {
  height: "2.5rem",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.border.main,
    },
  },
};

/**
 * Styles for input labels
 * @type {Object}
 */
export const inputLabel = {
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
};

/**
 * Styles for select dropdowns
 * @type {Object}
 */
export const select = {
  height: "2.5rem",
  fontFamily: theme.typography.fontFamily,
  width: "100%",
  // minWidth: 180,
};

/**
 * Styles for toggle button group
 * @type {Object}
 */
export const toggleButtonGroup = {
  display: "flex",
  height: "2.5rem",
  borderRadius: "0.5rem",
  overflow: "hidden",
  border: `1px solid ${theme.palette.border.disabled}`,
  fontFamily: theme.typography.fontFamily,
};

/**
 * Function to generate dynamic styles for toggle buttons
 * @param {boolean} isSelected - Whether button is selected
 * @param {number} index - Button index
 * @param {number} total - Total buttons
 * @returns {Object} - Style object
 */
export const getToggleButtonStyles = (isSelected, index, total) => ({
  flex: 1,
  textTransform: "none",
  minHeight: "2.5rem",
  backgroundColor: `${
    isSelected ? theme.palette.primary.main : theme.palette.background.default
  } !important`,
  color: `${
    isSelected ? theme.palette.text.secondary : theme.palette.text.primary
  } !important`,
  borderRadius: getBorderRadius(index, total),
  fontFamily: theme.typography.fontFamily,
  "&:hover": {
    backgroundColor: isSelected
      ? theme.palette.primary.dark
      : theme.palette.action.hover,
  },
});

/**
 * Styles for tires and accessories section
 * @type {Object}
 */
export const tiresAccessoriesContainer = {
  width: "100%",
  marginTop: "1rem",
};

/**
 * Styles for damage sections
 * @type {Object}
 */
export const damageContainer = {
  width: "100%",
  marginTop: "0.5rem",
};

/**
 * Styles for section subtitles
 * @type {Object}
 */
export const subtitle = {
  variant: "subtitle1",
  fontWeight: "bold",
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.text.primary,
};
